module.exports = __webpack_public_path__ + "img/horizontal_7_1_7016.505853f1.png";